import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: 0,
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_Party: "",
    A_PartyName: "",
    // A_Type: "",
    
  
    A_Narr: "",
    A_DocStat: "ENTER",
    TaxType: "", //tax  ->      // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
    TaxTypeName: "",
     
    TransferType: "",
 
    
    A_FromLocName:"",
    A_FromLoc:"", 
    
    
    A_ToLoc: "",
   
    A_ToLocName:"",
    RefCd:"",
    RefName:""
  },
  // BufferObject: {
  //   B_VocTyp: "",
  //   B_VocNo: "",
  //   B_Srno: 0,
  //   B_Itmcd: "",
  //   B_ItmName: "",
  //   B_Qty: 0,
  //   B_Unit: "",
  //   B_UnitName: "",
  //   B_BaseQty: 0,
  //   B_URateFc: 0,
  //   B_URateLc: 0,
  //   B_GrossAmt: 0,
  //   B_LDiscPerc: 0,
  //   B_LDiscAmt: 0,
  //   B_TDiscPerc: 0.00,
  //   B_TDiscAmt: 0,
  //   B_FocFlag: "N",
  //   B_AprmtFlag: "",
  //   B_FocAmt: 0,
  //   B_NetAmt: 0,
  //   B_TaxDept: "",
  //   B_TaxPerc: 0,
  //   B_TaxAmt: 0,
  //   B_TaxDept2: "",
  //   B_TaxPerc2: 0,
  //   B_TaxAmt2: 0,
  //   B_LC: 0,
  //   B_Charges1: 0,
  //   B_Charges2: 0,
  //   B_Rounding: 0,
  //   B_LandVal: 0,
  //   B_RSP: 0,
  //   B_RefDocTyp: "",
  //   B_RefDocNo: "",
  //   B_RefNo1: "",
  //   B_RefNo2: "",
  //   B_RefNo3: "",
  //   B_RefNo4: 0,
  //   B_RefNo5: 0,
  //   B_RefNo6: 0,
  //   B_URate_Fixed: 0,
  //   B_CostPr: 0,
  //   B_ExciseTaxPerc: 0,
  //   B_ExciseTaxAmt: 0,
  //   B_ExciseTaxNetAmt: 0,
  //   B_IncGroup: "",
  //   B_SuprvPerc: 0,
  //   B_OthersPerc: 0,
  //   B_SLANSuprv: "",
  //   B_SlabAmtSuprv: 0,
  //   B_SLANOther: "",
  //   B_SlabAmtOther: 0
  // },

  Checkbox: {
    // RefDoc: false,
    ItemCode: false,
    PackQty:true
  },
};

const SliceStockTransferRequest = createSlice({
  name: "SliceStockTransferRequest",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_StockTransferRequest_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    //RESET CHECKBOX
    Set_ModelCheckbox_Init: (state) => {
      state.value.Checkbox = {
        RefDoc: false,
        ItemCode: false,
        
      };
    },

    Set_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_ModelCheckbox: (state, action) => {
      state.value.Checkbox = action.payload;
    },

    HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;  
      state.value.HeadObject.TransferType = action.payload.TransferType; 
    },
   
    Set_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    
  },
});

export const {
  Set_StockTransferRequest_Init,
  Set_HeadObject_Set,
  Set_ModelCheckbox,
  Set_ModelCheckbox_Init,
  HeadObject_New_Set,
  Set_HeadObject_Init,
  Set_HeadObject_A_VocNo,
  Set_HeadObject_A_DocStat,   
} = SliceStockTransferRequest.actions;
export default SliceStockTransferRequest.reducer;
